import { HttpContextToken } from '@angular/common/http';

/** When true on a request, {@link BaseInterceptor} does not show the global overlay loader. */
export const SKIP_GLOBAL_LOADER = new HttpContextToken<boolean>(() => false);
